
export default class CategoriesBase{
    constructor(categories, itemsListCategories) {
        this.categories = categories
        this.itemsListCategories = itemsListCategories || categories
    }
    
    getCategoryOfState = state => Object.keys(this.itemsListCategories).filter(cat => this.itemsListCategories[cat].includes(state))[0]
    getCategoryStates = category => this.categories[category]
}